"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ManufacturedSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<g stroke="none"><path fill-rule="evenodd" d="M4.821 4.212A2 2 0 0 1 6.66 3h18.682a2 2 0 0 1 1.838 1.212l2.143 5A2 2 0 0 1 27.484 12H27v9a2 2 0 0 1-2 2v2a1 1 0 1 1-2 0v-2h-2v2a1 1 0 1 1-2 0v-2H7a2 2 0 0 1-2-2v-9h-.483a2 2 0 0 1-1.839-2.788l2.143-5ZM10 16a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h-5v-5Z" clip-rule="evenodd"></path><path d="M9 24a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2H9Z"></path><path d="M7 28a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Z"></path></g>';
var ManufacturedSVG = function ManufacturedSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.ManufacturedSVG = ManufacturedSVG;
ManufacturedSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ManufacturedSVG);
exports.default = _default;